import React from 'react';

// Debug panel, shown only when the URL has ?debugLiveAgent=1.
function LiveAgentDiagnostics({ diagnostics }) {
  const { connection, accepted, rejected, lastEvent } = diagnostics;

  return (
    <aside className="live-agent-diagnostics" aria-live="polite">
      <strong>Live-agent diagnostics</strong>
      <span>DirectLine: {connection}</span>
      <span>agentmessages accepted/appended: {accepted} | rejected: {rejected}</span>
      <span>
        Last event: {lastEvent
          ? `${lastEvent.result} at ${lastEvent.receivedAt} (type: ${lastEvent.type}, sender: ${lastEvent.sender}, id: ${lastEvent.activityId})`
          : 'Waiting for agentmessages'}
      </span>
    </aside>
  );
}

export default LiveAgentDiagnostics;
